/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */
export function getProductWindow(): Window | null {
	// This would need to be changed if we want to support multiple nesting levels
	const targetWindow = window.parent?.parent;

	// Ensure we have a valid target that's not the current window
	if (targetWindow && targetWindow !== window) {
		return targetWindow;
	}

	return null;
}

/**
 * Gets the target domain for post-robot messages.
 * Uses protocol + hostname to allow different ports (for local dev).
 *
 * @returns Domain string like "http://localhost" or "https://atlassian.com"
 */
export function getProductDomain(): string {
	return `${window.location.protocol}//${window.location.hostname}`;
}
